import { render, staticRenderFns } from "./push-configuration.vue?vue&type=template&id=b46cd9ee&scoped=true"
import script from "./push-configuration.vue?vue&type=script&lang=js"
export * from "./push-configuration.vue?vue&type=script&lang=js"
import style0 from "./push-configuration.vue?vue&type=style&index=0&id=b46cd9ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46cd9ee",
  null
  
)

export default component.exports